import axios, { AxiosInstance } from "axios";
import { firebaseApp } from "../../utils/firebase";
import { ICheckStrategy } from "./IConnectionCheck";
import { captureException } from "@sentry/react";

export class FirebaseDisconnectCheck implements ICheckStrategy {
	http: AxiosInstance;
	constructor() {
		this.http = axios.create({
			baseURL: firebaseApp.options.databaseURL,
		});
	}

	async check() {
		try {
			await this.http.options("/?no-cache");
			console.log("Firebase is connected");
			return {
				status: "ok" as const,
				resourceName: "Internet",
				message: "Conectado",
			};
		} catch (error) {
			captureException(error);
			console.error("Firebase is disconnected", error);
			return {
				status: "error" as const,
				message: "Sem conexão com a internet",
				resourceName: "Internet",
			};
		}
	}
}
